import axios from "axios";

import { config } from "shared/data";

import { LayoutVariant } from "scmp-app/pages/home/styles";

interface HomepageCustomWidgetsConfig {
  thingsToDoPromotedByPlus: string;
}

export const getHomePageLayoutVariant = async () => {
  const resp = await axios.get<HomepageCustomWidgetsConfig>(
    `https://${config.general.cdn.host}/data/homepage-custom-widgets.json`,
  );
  return resp?.data?.thingsToDoPromotedByPlus === "on"
    ? LayoutVariant.ThingsToDoPromotedByPlus
    : LayoutVariant.Default;
};
